import type * as SentryTypes from '@sentry/browser';
import { env } from '../../config/env.js';

/**
 * Error tracking in the browser.
 *
 * Off unless the build carries `VITE_SENTRY_DSN`, and loaded only then, so a
 * build without it ships none of the SDK. It hears about crashes the error
 * page shows; never form contents, never addresses, never figures.
 */
type SentryModule = typeof SentryTypes;
let loading: Promise<SentryModule> | null = null;

export function initErrorTracking(): void {
  const dsn = env.VITE_SENTRY_DSN;
  if (dsn === undefined) return;
  loading = import('@sentry/browser').then((Sentry) => {
    Sentry.init({
      dsn,
      environment: env.VITE_APP_ENV,
      dataCollection: {
        userInfo: false,
        cookies: false,
        httpHeaders: false,
        httpBodies: [],
        urlQueryParams: false,
      },
      tracesSampleRate: 0,
      beforeSend(event) {
        delete event.user;
        if (event.request) delete event.request.data;
        return event;
      },
    });
    return Sentry;
  });
}

export function reportError(error: unknown, tags: Readonly<Record<string, string>> = {}): void {
  void loading?.then((Sentry) => {
    Sentry.withScope((scope) => {
      scope.setTags(tags);
      Sentry.captureException(error);
    });
  });
}
